<template>
  <div id="absent_student">
    <div class="absent_content" v-for="item in info" :key="item.id">
      <div class="absent_title">{{ item.schoolName }} {{ item.className }}</div>
      <div class="ansent_kind">
        <div class="absent_kind_stu">姓名</div>
        <div class="absent_kind_sch">家长联系方式</div>
      </div>



      <!--            学生联系-->
      <div class="absent_stu_info" v-for="(stu_info, idx) in item.missChildListVMS" :key="idx">
        <!--                学生姓名-->
        <div class="info_name">
          <div class="info_name_con">
            <span style="margin-right: 5px;">{{ stu_info.name }}</span>

            <!-- <van-button v-if="stu_info.isSignIn === 0" hairline type="primary" round size="mini">已补签</van-button>
            <van-button v-if="stu_info.isSignIn !== 0" hairline type="success" round size="mini"
              @click="handleSignIn(stu_info)">补签</van-button> -->
          </div>
        </div>
        <!--                联系方式-->
        <div class="info_detail">
          <div class="info_detail_con">
            <span v-for="(tel, tel_idx) in stu_info.parentList" :key="tel_idx">
              <span> {{ tel.relationship ? parentList[tel.relationship] + '：' : tel.name }}</span>
              <!-- <a :href="'tel:' + tel.mobile">{{ tel.mobile }}</a> -->
              <span v-if="!tel.isShowMobile">{{ tel.mobile }}</span>
              <a v-if="tel.isShowMobile" :href="'tel:' + tel.noMobile">{{ tel.noMobile }}</a>
              <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                @click="getTeacherOrParentMobile(tel, tel.isShowMobile)"
                v-if="!tel.isShowMobile && tel.name != '该学生未绑定家长'" name="eye-o" />
              <van-icon style="text-indent: 0;font-size: 15px;margin-left: 3px;"
                @click="getTeacherOrParentMobile(tel, tel.isShowMobile)" v-if="tel.isShowMobile" name="closed-eye" />
            </span>

          </div>

          <div class="info_btn_con">
            <van-button style="width: 30%" v-if="stu_info.contactedParents === null" size="mini" type="info" round
              @click="handleSignInPerson(stu_info)">已和家长联系</van-button>

            <div style="font-size: .8rem;margin-right: 10px;" v-if="stu_info.contactedParents === 0">已和家长联系</div>

            <van-button style="width: 30%" v-if="stu_info.isSignIn !== 0 " size="mini" type="info"
              round @click="handleSignIn(stu_info)">补签</van-button>
            <van-button style="width: 30%" v-if="stu_info.isSignIn === 0" size="mini" type="primary"
              round>已补签</van-button>

          </div>
        </div>
      </div>




    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from "@/store";
export default {
  name: "absent-student",
  data() {
    return {
      // 未到校学生信息
      info: [],
      titleInfo: {},
      params: {
        toDay: '',
        schoolId: '',
        appId: ''
      },
      // 待实现
      classId: '', // 根据classId显示各自班级的未到学生清单 ( 待实现 )
      parentList: ['爸爸', '妈妈', '爷爷', '奶奶', '外婆', '外公', '哥哥', '姐姐', '其他亲属', '伯父', '伯母', '叔叔', '婶婶', '姑父', '姑母', '舅舅', '舅妈', '姨夫', '姨妈', '嫂嫂', '姐夫']
    };
  },

  created() {
    this.params.schoolId = this.getParams('schoolId')
    this.params.toDay = this.getParams('toDay')
    this.params.appId = this.getParams('appId')
    this.classId = this.getParams('classId')  //获取指定班级的学生未到信息
    console.log('this.params', this.params);
    this.getStudentList()
  },
  methods: {
    // 获取参数
    getParams(name) {
      console.log(window.location)
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      console.log('r', r)

      return r ? unescape(r[2]) : '';
    },
    getTeacherOrParentMobile(data, bol) {
      if (!data.noMobile) { // 没有手机号
        this.$https.getMobileById({
          id: data.id
        }).then(res => {
          if (res.code == 200) {

            data.noMobile = res.data
            data.isShowMobile = !bol

          } else {
            this.$toast(res.msg)
          }
        })
      } else { // 有手机号
        data.isShowMobile = !bol
      }
    },

    // 补签接口
    async handleSignIn(res) {
      const { data, code } = await this.$https.notInSchoolSignInPlatform({
        userId: res.id,
        date: this.params.toDay,
        clockType: res.clockType
      })
      if (code == 200) {
        this.$toast('补签成功')
        this.getStudentList()
      } else {
        this.$toast('补签失败')
      }
    },
    async handleSignInPerson(res) {
      const { data, code } = await this.$https.notInSchoolContactedParents({
        userId: res.id,
        date: this.params.toDay
      })
      if (code == 200) {
        // this.$toast('补签成功')
        this.getStudentList()
      } else {
        this.$toast('补签失败')
      }
    },
    async getStudentList() {
      const { data, code } = await this.$https.getStudentList(this.params)
      if (code == 200 && data) {
        console.log('获取到数据', data.find(item => item.id == this.classId), this.classId)



        if (this.classId) {
          let newData = [data.find(item => item.id == this.classId)]
          newData.forEach(item => {
            item.missChildListVMS.forEach(stu => {
              if (stu.parentList) {
                stu.parentList.forEach(parent => {
                  parent.isShowMobile = false
                })
              }
              if (stu.teacherList) {
                stu.teacherList.forEach(parent => {
                  parent.isShowMobile = false
                })
              }
            })
          })
          this.info = [data.find(item => item.id == this.classId)]
        } else {
          data.forEach(item => {
            item.missChildListVMS.forEach(stu => {
              if (stu.parentList) {
                stu.parentList.forEach(parent => {
                  parent.isShowMobile = false
                })
              }
              if (stu.teacherList) {
                stu.teacherList.forEach(parent => {
                  parent.isShowMobile = false
                })
              }
            })
          })
          this.info = data
        }
        //  this.info[0].isShow = true
      }


    }
  },
};
</script>

<style lang="scss" scope>
.absent_content {
  margin: 0rem 1rem 1rem 1rem;
}

.absent_title {
  height: 2rem;
  background-color: #70B1FF;
  font-size: .8rem
    /* 16/20 */
  ;
  color: #fff;
  line-height: 2rem;
  text-align: center;
}

.ansent_kind {
  height: 1.5rem
    /* 30/20 */
  ;
  display: flex;
  border-left: .05rem
    /* 1/20 */
    solid #ccc;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
  background-color: #DBEAFF;
}

.absent_kind_stu,
.absent_kind_sch {
  font-size: .9rem
    /* 14/20 */
  ;
  line-height: 1.5rem
    /* 30/20 */
  ;
  text-align: center;
  color: #3E4D61;
}

.absent_kind_stu {
  flex: 1;
}

.absent_kind_sch {
  flex: 5;
}

.absent_stu_info {
  width: 100%;
  display: flex;
  border-left: .05rem
    /* 1/20 */
    solid #ccc;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
}

.info_name {
  flex: 1.5;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  font-size: .7rem
    /* 14/20 */
    /* 12/20 */
    /* 14/20 */
  ;
  border-right: .05rem
    /* 1/20 */
    solid #ccc;
  border-bottom: .05rem
    /* 1/20 */
    solid #ccc;

  .info_name_con {
    display: flex;
    align-items: center;
  }
}

.info_detail {
  padding: 0 .5rem .5rem;
  flex: 5;
  // flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  border-bottom: .05rem solid #ccc;

  .info_detail_con {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

  }

  .info_btn_con {
    margin: 5px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}

.info_detail>.info_detail_con>span>a {
  font-style: normal;
  color: darkblue;
  text-decoration: none
}

.info_detail>.info_detail_con>span {
  width: 50%;
  font-size: .8rem
    /* 12/20 */
  ;
  display: block;
  margin-top: .5rem
    /* 10/20 */
  ;
}

#absent_student {
  margin-bottom: 2.5rem
    /* 50/20 */
  ;
  padding-top: 1rem;
}
</style>
